import { ECreateScanMode } from 'src/types'
import * as Yup from 'yup'

interface IProps {
  withMovement: boolean
  withImpact: boolean
  scanMode: ECreateScanMode
}

export const scanCreateSchema = ({ withMovement, withImpact, scanMode }: IProps) =>
  Yup.object().shape({
    account_id: Yup.string().required('validation-required'),
    product_id:
      scanMode === ECreateScanMode.AccountImpact
        ? Yup.string().nullable().notRequired()
        : Yup.string().required('validation-required'),

    step_id:
      scanMode === ECreateScanMode.ProductImpact || scanMode === ECreateScanMode.AccountImpact
        ? Yup.string().nullable().notRequired()
        : Yup.string().required('validation-required'),

    scanner_latitude: Yup.number().required('validation-required'),
    scanner_longitude: Yup.number().required('validation-required'),

    batch_id: Yup.string().nullable().notRequired(),

    // sender_reference_id: withMovement
    //   ? Yup.string().nullable().required('validation-required')
    //   : Yup.string().nullable(),
    // receiver_reference_id: withMovement
    //   ? Yup.string().nullable().required('validation-required')
    //   : Yup.string().nullable(),
    // invoice_reference: withMovement
    //   ? Yup.string().nullable().required('validation-required')
    //   : Yup.string().nullable(),
    sender_reference_id: Yup.string().nullable(),
    receiver_reference_id: Yup.string().nullable(),
    invoice_reference: Yup.string().nullable(),

    impact_id: withImpact
      ? Yup.string().nullable().required('validation-required')
      : Yup.string().nullable(),
    impact_quantity: Yup.string().nullable(),

    note: Yup.string().max(1000, 'validation-note-max'),
  })
